import React from 'react';
import { Link } from 'react-router-dom';
import './Teams.css';

function Teams() {
  const teamMembers = [
    {
      name: 'rena (pwawli)',
      role: 'Co-Founder & Lead Builder',
      bio: 'Lead Builder, Animator, and Environment Artist. Focuses on worldbuilding, lighting, props, and character animation with a strong eye for style and atmosphere.',
      profileUrl: 'https://www.roblox.com/users/317565729/profile',
      avatarUrl: 'https://tr.rbxcdn.com/30DAY-AvatarHeadshot-D2D9822EB0A48BC2B7AAAC8FB0E54BD5-Png/150/150/AvatarHeadshot/Webp/noFilter',
      skills: ['Level Design', 'Animation', 'Worldbuilding', 'Lighting', 'Art Direction']
    },
    {
      name: 'iownrena',
      role: 'Co-Founder & Lead Developer',
      bio: 'Lead Developer, Scripter, and Systems Designer. Specializes in gameplay mechanics, networking, backend systems, and Analytics.',
      profileUrl: 'https://www.roblox.com/users/1113882418/profile',
      avatarUrl: 'https://tr.rbxcdn.com/30DAY-AvatarHeadshot-0950F98901D3A1850FA83BC533B6563D-Png/150/150/AvatarHeadshot/Webp/noFilter',
      skills: ['Luau Scripting', 'System Design', 'Analytics', 'Networking', 'Backend Systems', 'Optimization']
    }
  ];

  return (
    <section id="teams" className="teams">
      <div className="container">
        <div className="section-header">
          <h2>Our Team</h2>
          <p>The people behind MeowBox Studios</p>
        </div>
        <div className="teams-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card">
              <div className="card-inner">
                <div className="avatar-wrapper">
                  <img 
                    src={member.avatarUrl} 
                    alt={member.name}
                    className="avatar-image"
                  />
                </div>
                <div className="member-info">
                  <h3>{member.name}</h3>
                  <p className="role">{member.role}</p>
                  <p className="bio">{member.bio}</p>
                  <div className="skills">
                    {member.skills.map((skill, i) => (
                      <span key={i} className="skill-tag">{skill}</span>
                    ))}
                  </div>
                  <div className="member-links">
                    <a 
                      href={member.profileUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="profile-link"
                    >
                      Roblox Profile
                    </a>
                    <Link 
                      to={index === 0 ? '/rena' : '/taylor'} 
                      className="profile-link portfolio-link"
                    >
                      View Portfolio
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Teams;
